function contactValue(value) {
  return value == null ? '' : String(value);
}

function hasContactValue(value) {
  return contactValue(value).trim().length > 0;
}

export function cloneClientContact(contact) {
  return {
    email: contactValue(contact?.email),
    phone: contactValue(contact?.phone),
  };
}

export function getCanonicalClientContacts(client = {}) {
  const source = client ?? {};
  const contattiPersonali = cloneClientContact(source.contattiPersonali);
  const contattiAziendali = cloneClientContact(source.contattiAziendali);

  if (
    !hasContactValue(contattiPersonali.email) &&
    !hasContactValue(contattiAziendali.email) &&
    hasContactValue(source.email)
  ) {
    contattiAziendali.email = contactValue(source.email);
  }

  if (
    !hasContactValue(contattiPersonali.phone) &&
    !hasContactValue(contattiAziendali.phone) &&
    hasContactValue(source.phone)
  ) {
    contattiAziendali.phone = contactValue(source.phone);
  }

  return {
    contattiPersonali,
    contattiAziendali,
  };
}

export function resolvePrimaryClientContact(client = {}, field, { allowLegacyFallback = true } = {}) {
  const source = client ?? {};
  const businessValue = contactValue(source.contattiAziendali?.[field]);
  if (hasContactValue(businessValue)) return businessValue;

  const personalValue = contactValue(source.contattiPersonali?.[field]);
  if (hasContactValue(personalValue)) return personalValue;

  return allowLegacyFallback ? contactValue(source[field]) : '';
}
